import React, { useState } from 'react';
import { ClipStage } from '../ClipStage';
import { TransformStage } from '../TransformStage';
import { useBeats } from '../../hooks/useBeats';
import { solutionClip, solutions } from '../../data/teaser';

// supporting line, then the three solution cards
const BEATS = [600, 1100, 1600, 2100];
export function ScreenSolution() {
  const beat = useBeats(BEATS);
  const [selected, setSelected] = useState<number | null>(null);
  const [explored, setExplored] = useState(false);
  const detail = selected === null ? null : solutions[selected];
  const pick = (index: number) => {
    setSelected(prev => prev === index ? null : index);
    setExplored(true);
  };
  return <section className="flex h-full w-full flex-col justify-start pt-1" data-id="element-102" data-mp="2z4oldj0dzmzu">
      <h1 className="text-[26px] font-extrabold leading-tight text-white animate-fade-in-up" data-id="element-103" data-mp="2z70x3efjx14g">
        Three variables.
        <br data-id="element-104" data-mp="385mhlf4l2q7v" />
        One different approach.
      </h1>

      <p className={`mt-2 font-body text-sm leading-snug text-solventum-primary transition-opacity duration-300 ${beat >= 1 ? 'opacity-100' : 'opacity-0'}`} data-id="element-105" data-mp="3865v8jn7asg3">
        Precision Grip removes the manual attachment-creation step.
      </p>

      {/* fixed visual slot — the reward swaps in place, never resizes the page */}
      <div className="mt-4 h-32" data-id="element-106" data-mp="pzr50v6amaov">
        {detail ? <TransformStage key={detail.name} solution={detail} data-id="element-107" data-mp="q1c0qo4cfzob" /> : <ClipStage clip={solutionClip} heightClass="h-32" frameMs={900} data-id="element-108" data-mp="1nmgefq3brpkr" />}
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2" data-id="element-109" data-mp="1ip7xfstwxrl3">
        {solutions.map((solution, index) => {
        const isSelected = selected === index;
        const isDimmed = selected !== null && !isSelected;
        return <button key={solution.name} onClick={() => pick(index)} aria-pressed={isSelected} aria-label={`${solution.name}: ${solution.cardHeadline}`} className={`rounded-xl border px-2 py-3 font-headline text-base font-extrabold transition-all duration-300 ${beat >= index + 2 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'} ${isSelected ? 'border-solventum-primary bg-solventum-primary text-solventum-bg' : isDimmed ? 'border-white/10 bg-white/[0.02] text-white/45' : 'border-white/15 bg-white/[0.04] text-white'}`} data-id="element-110" data-mp="18vzbg2b1krlr" data-mpi={index}>
              {solution.name}
            </button>;
      })}
      </div>

      {/* fixed explanation slot so nothing pushes into the navigation */}
      <div className="mt-3 h-[100px]" data-id="element-111" data-mp="386207f6j4hbz">
        {detail ? <div key={detail.name} className="h-full overflow-hidden rounded-2xl border border-solventum-primary/40 bg-solventum-primary/[0.06] px-3 py-2.5 animate-rise-in" data-id="element-112" data-mp="11ekqhxd0n35j">
            <p className="font-headline text-base font-extrabold leading-tight text-solventum-primary" data-id="element-113" data-mp="1ghcemx156mpg">
              {detail.cardHeadline}
            </p>
            <p className="mt-1 font-body text-[12px] leading-[1.35] text-white/85" data-id="element-114" data-mp="1bk2eong4msnd">
              {detail.body}
            </p>
          </div> : <p className={`px-1 font-body text-[13px] text-white/40 transition-opacity duration-300 ${beat >= 4 ? 'opacity-100' : 'opacity-0'}`} data-id="element-115" data-mp="1kinvoe5y9zm1">
            Tap Shape, Position or Flash to see what changes.
          </p>}
      </div>

      <div className={`mt-3 transition-all duration-300 ${explored ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} aria-hidden={!explored} data-id="element-116" data-mp="289a4i7ns3nx3">
        <p className="font-headline text-lg font-extrabold leading-snug text-white" data-id="element-117" data-mp="duhd6ktxhjay">
          Less manual variability. More consistency with the digital plan.
        </p>
        <p className="mt-1.5 font-headline text-base font-extrabold leading-snug text-solventum-primary" data-id="element-118" data-mp="9vi890875mji">
          And 12 minutes saved per bonding procedure, on average.
        </p>
      </div>
    </section>;
}